import APIContext from 'contexts/base/APIContext'

export default class LogBooksContext extends APIContext{
  static contextName = 'logBooks'
}
